export default __webpack_public_path__ + "Google_EN.0a6e345f.svg";